module.exports = __webpack_public_path__ + "static/media/kickstarter-k.9b2bd0d1.svg";